module.exports = __webpack_public_path__ + "static/Sand World-36463a67f1691d0044d94432c4dcdadc.svg";